import { useEffect, useRef, useState } from 'react';
export function useRequest({ request, initial, deps }) {
    const [response, setResponse] = useState(initial);
    const requestCount = useRef(0);
    useEffect(() => {
        const currentRequest = ++requestCount.current;
        if (requestCount.current === 1 && initial) {
            // No need to do an initial fetch if initial data was provided
            return;
        }
        request().then((result) => {
            if (currentRequest === requestCount.current) {
                setResponse(result);
            }
        });
    }, deps);
    return response;
}
